/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserApplicationPreferencesResponse } from '../../models/user-application-preferences-response';

export interface GetUserApplicationPreferences$Params {
  componentIds?: string;
}

export function getUserApplicationPreferences(http: HttpClient, rootUrl: string, params?: GetUserApplicationPreferences$Params, context?: HttpContext): Observable<StrictHttpResponse<UserApplicationPreferencesResponse>> {
  const rb = new RequestBuilder(rootUrl, getUserApplicationPreferences.PATH, 'get');
  if (params) {
    rb.query('componentIds', params.componentIds, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserApplicationPreferencesResponse>;
    })
  );
}

getUserApplicationPreferences.PATH = '/api/v1/session/application-preferences';
